/* eslint-disable react/require-default-props */
import { ActionIcon, ActionIconVariant, Button, Group, Popover, Stack, Text, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useState } from 'react';

type Props = {
  label: string;
  message?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  disabled?: boolean;
  variant?: ActionIconVariant;
  zIndex?: number;
};

export default function DeleteConfirmPopover(props: Props) {
  const { label, message, onConfirm, disabled, variant, zIndex } = props;
  const [opened, setOpened] = useState(false);

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position="bottom-end"
      withArrow
      shadow="md"
      withinPortal
      zIndex={zIndex ? zIndex + 1 : undefined}
    >
      <Popover.Target>
        <Tooltip label={label} withArrow zIndex={zIndex ? zIndex + 1 : undefined}>
          <ActionIcon
            size="sm"
            color="red"
            variant={variant || 'light'}
            disabled={disabled}
            onClick={() => setOpened((current) => !current)}
          >
            <IconTrash size={15} />
          </ActionIcon>
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="xs">
          <Text size="sm" fw={500}>
            Confirmar exclusão?
          </Text>
          <Text size="xs" c="dimmed">
            {message || 'Esta ação removerá o item.'}
          </Text>
          <Group justify="flex-end" gap="xs">
            <Button
              size="xs"
              variant="default"
              onClick={() => {
                setOpened(false);
                // eslint-disable-next-line react/destructuring-assignment
                props.onCancel?.();
              }}
            >
              Cancelar
            </Button>
            <Button
              size="xs"
              color="red"
              onClick={() => {
                setOpened(false);
                onConfirm();
              }}
            >
              Excluir
            </Button>
          </Group>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
